import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowGetPatientBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.GetPatient),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Patient),
    config: z.object({}),
});
//# sourceMappingURL=config.js.map